export enum EditableCardType {
  Billing = 'Billing',
  ContactInformation = 'ContactInformation',
  Shipping = 'Shipping',
  None = 'None',
}

export enum ScrubAddressModalType {
  Address = 'AddressValidation',
  AddressError = 'AddressError',
  IncorrectAddress = 'IncorrectAddress',
  Unsaved = 'UnsavedChanges',
}
